import { ref, onMounted, onBeforeUnmount } from 'vue';
import { emitter } from 'shared/helpers/mitt';

// SiteUp: escuta o evento global 'kanban:appointment:scheduled' (emitido pela
// camada da API sempre que um item é salvo com um compromisso).
//
// Decisão 18 (kanban-layout-r3): a ABERTURA AUTOMÁTICA foi desligada. Quem
// avisa o cliente agora é a etapa de conferência do formulário único
// (ScheduleModal), que mostra a prévia ANTES de gravar em vez de um popup que
// aparecia sozinho depois. O composable e o KanbanAppointmentModal continuam
// existindo para não quebrar quem ainda dispara o evento ou monta o modal, mas
// `open` só muda por quem chama `openFor` de propósito.
export function useKanbanAppointmentPopup() {
  const open = ref(false);
  const itemId = ref(null);
  const scheduledAt = ref('');

  // Registrado só para manter o par on/off e o contrato do evento; não abre
  // mais nada por conta própria.
  const onScheduled = payload => {
    const id = payload?.itemId;
    if (!id) return;
    itemId.value = String(id);
    scheduledAt.value = payload?.scheduledAt || '';
  };

  // Abertura explícita, para telas que ainda queiram o fluxo antigo.
  const openFor = (id, sa = '') => {
    if (!id) return;
    itemId.value = String(id);
    scheduledAt.value = sa;
    open.value = true;
  };

  onMounted(() => emitter.on('kanban:appointment:scheduled', onScheduled));
  onBeforeUnmount(() =>
    emitter.off('kanban:appointment:scheduled', onScheduled)
  );

  return { open, itemId, scheduledAt, openFor };
}
